<template>
  <div>
    <Header :breadcrumsfirst="breadcrumsfirst" :breadcrumslast="breadcrumslast" />
    <Filter :button="filterConfig.buttonConfig" />

    <div class="table-data">
      <table class="table table-hover table-responsive">
        <thead class="table-light">
          <tr>
            <th scope="col" width="280">Filename</th>
            <th scope="col" >Repository</th>
            <th scope="col" >File Type</th>
            <th scope="col" >Month</th>
            <th scope="col" >Year</th>
            <th scope="col" >Enable</th>
            <th scope="col" >Disable</th>
            <th scope="col" >Delete</th>
            <th ></th>
            <!-- <th scope="col">
                <span class="d-flex justify-content-end">
                  <tableHeadingIcon />
                </span>
  
              </th> -->
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in tableData" :key="index">
            <td>{{ item.filename }}</td>
            <td>{{ item.repository }}</td>
            <td>{{ item.filetype }}</td>
            <td>{{ item.month }}</td>
            <td>{{ item.year }}</td>
            <td>
              <!-- <div class="form-switch">
    <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" checked>
  </div> -->
              <button type="submit" class="btn btn-primary enable-button"
                @click="fileEnabled(item.repository, item.filename)" :disabled="item.isenable === 0">Enable</button>
            </td>
            <td>
              <button type="submit" class="btn btn-primary enable-button"
                @click="fileDisabled(item.repository, item.filename)" :disabled="item.isdisable === 0">Disable</button>
            </td>
            <td>
              <button type="submit" class="btn btn-danger list-delete-button" data-bs-toggle="modal"
              data-bs-target="#exampleModal" :disabled="item.isdelete === 0" @click="selectedItem = item"
                >Delete</button>
            </td>
            <td>
    <div class="modal fade modal-sm" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" >
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="exampleModalLabel"></h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        Are you sure you want to delete this record?
      </div>
      <div class="modal-footer">
        <!-- <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button> -->
        <button type="button" class="btn btn-danger btn-sm delete-button"  data-bs-dismiss="modal" @click="fileDelete(selectedItem.repository, selectedItem.filename)">Delete Record</button>
      </div>
    </div>
  </div>
</div>

            </td>
          </tr>
        </tbody>
      </table>
      <div class="pagination-container">
        <div class="items-per-page">
          <label for="itemsPerPage">Records Per Page:</label>
          <select id="itemsPerPage" class="items-per-page-dropdown" v-model="pageSize" @change="changePageSize">
            <option v-for="option in pageSizeOptions" :value="option">{{ option }}</option>
          </select>
        </div>
        <div class="total-entries">
          <span>Total Records: {{ totalCount }}</span>
        </div>
        <div class="pagination">
          <ul class="pagination-list">
            <li @click="gotoPage(1)"><a><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22"
                  fill="currentColor" class="bi bi-skip-start-fill" viewBox="0 0 16 16">
                  <path
                    d="M4 4a.5.5 0 0 1 1 0v3.248l6.267-3.636c.54-.313 1.232.066 1.232.696v7.384c0 .63-.692 1.01-1.232.697L5 8.753V12a.5.5 0 0 1-1 0z" />
                </svg></a></li>
            <li @click="prevPage()"><a><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                  fill="currentColor" class="bi bi-chevron-left" viewBox="0 0 16 16">
                  <path fill-rule="evenodd"
                    d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0" />
                </svg></a></li>
            <li v-for="pageNumber in visiblePages" :key="pageNumber" :class="{ active: pageNumber === currentPage }"
              class="ellipsis-icon" @click="gotoPage(pageNumber)">
              <template v-if="pageNumber === 'dots'">
                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-three-dots" viewBox="0 0 16 16">
                    <path
                      d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3" />
                  </svg>
                </span>
              </template>
              <template v-else>
                <a>{{ pageNumber }}</a>
              </template>
            </li>

            <li @click="nextPage()"><a><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                  fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
                  <path fill-rule="evenodd"
                    d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708" />
                </svg></a></li>
            <li @click="gotoPage(totalPages)"><a><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22"
                  fill="currentColor" class="bi bi-skip-end-fill" viewBox="0 0 16 16">
                  <path
                    d="M12.5 4a.5.5 0 0 0-1 0v3.248L5.233 3.612C4.693 3.3 4 3.678 4 4.308v7.384c0 .63.692 1.01 1.233.697L11.5 8.753V12a.5.5 0 0 0 1 0z" />
                </svg></a></li>
          </ul>
        </div>
      </div>

    </div>
  </div>
</template>
  
  <script>
  import Header from '@/components/Header.vue';
  import Filter from '@/components/Filter.vue';
  // import editIcon from '@/components/edit-icon.vue';
  // import tableHeadingIcon from '@/components/table-heading-icon.vue';
  import { getArchivalList, getFileEnabled, getFileDisbled, getFileDelete } from "@/http/archival/list-data.http"
  export default {
    name: "archival-history",
    components: {
      Header,
      Filter,
      // editIcon,
      // tableHeadingIcon
    },
    data() {
      return {
        breadcrumsfirst: "Archival",
        breadcrumslast: "List Data",
        filterConfig: {
          buttonConfig: {
            show: false,
            link: ''
          }
        },
        selectedItem: null,
        tableData: [],
        currentPage: 1,
        pageSize: 5,
        totalCount: 0,
        pageSizeOptions: [5, 10, 20], // Define your options for items per page
      };
    },
    computed: {
      totalPages() {
        return Math.ceil(this.totalCount / this.pageSize);
      },
      visiblePages() {
        const totalVisiblePages = 3; // Change this as needed
        const pages = [];
        let startPage = 1;
        let endPage = this.totalPages;

        if (this.totalPages > totalVisiblePages) {
          const halfVisiblePages = Math.floor(totalVisiblePages / 2);
          startPage = Math.max(this.currentPage - halfVisiblePages, 1);
          endPage = startPage + totalVisiblePages - 1;

          if (endPage > this.totalPages) {
            startPage -= endPage - this.totalPages;
            endPage = this.totalPages;
          }

          if (startPage > 1) {
            pages.push(1);
            if (startPage > 2) {
              pages.push('dots');
            }
          }
        }

        for (let i = startPage; i <= endPage; i++) {
          pages.push(i);
        }

        if (endPage < this.totalPages) {
          if (endPage < this.totalPages - 1) {
            pages.push('dots');
          }
          pages.push(this.totalPages);
        }

        return pages;
      }
    },
    methods: {
      fetchData() {
        getArchivalList({
          index: this.currentPage,
          pagesize: this.pageSize
        })
          .then(response => {
            if (!response || response.length === 0) {
              this.tableData = [];
              this.totalCount = 0
            } else {
              this.tableData = response.list;
              this.totalCount = response.recordcount.totalcount;
            }
          
          })
          .catch(error => {
            console.error('Error fetching data:', error);
          });
      },
      gotoPage(pageNumber) {
        if (pageNumber >= 1 && pageNumber <= this.totalPages) {
          this.currentPage = pageNumber;
          this.fetchData();
        }
      },
      prevPage() {
        if (this.currentPage > 1) {
          this.currentPage--;
          this.fetchData();
        }
      },
      nextPage() {
        if (this.currentPage < this.totalPages) {
          this.currentPage++;
          this.fetchData();
        }
      },
      changePageSize() {
        this.currentPage = 1; // Reset to the first page when changing page size
        this.fetchData();
      },

      fileEnabled(repository, filename) {

        const payload = {
          filename: `${repository}/${filename}`
        };

        getFileEnabled(payload).then(() => {
          this.fetchData()
        }).catch(error => {
          console.error('Error enabling file:', error);
        });
      },
      fileDisabled(repository, filename) {

        const payload = {
          filename: `${repository}/${filename}`
        };

        getFileDisbled(payload).then(() => {
          this.fetchData()
        }).catch(error => {
          console.error('Error disabling file:', error);
        });
      },
      fileDelete(repository, filename) {

        const payload = {
          filename: `${repository}/${filename}`
        };

        getFileDelete(payload).then(() => {
          this.currentPage = 1
          this.fetchData()
        }).catch(error => {
          console.error('Error disabling file:', error);
        });
      },
    },
    mounted() {
      this.fetchData();
    }

  };
</script>
  
  <style>
 
</style>
  
